"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.embedGroupFolderId = exports.embedUserFolderId = exports.rootFolderId = void 0;
const rootFolderId = 1;
exports.rootFolderId = rootFolderId;
const embedUserFolderId = 3;
exports.embedUserFolderId = embedUserFolderId;
const embedGroupFolderId = 4;
exports.embedGroupFolderId = embedGroupFolderId;
